import { array, Infer, is, object, optional, string } from 'superstruct';
import { useFeatureServices } from './use-feature-services';

const videosContent = object({
  videoId: optional(string()),
  title: optional(string()),
  body: optional(string()),
  linkText: optional(string()),
  linkUrl: optional(string()),
  captionText: optional(string()),
  altText: optional(string()),
  disclaimers: optional(string()),
  videoMaxWidth: optional(string()),
  videoWidth: optional(string()),
  videoMargin: optional(string()),
});

const marginContent = object({
  mobile: optional(string()),
  tablet: optional(string()),
  desktop: optional(string()),
});

const disclaimersContent = object({
  token: optional(string()),
  number: optional(string()),
  description: optional(string()),
});

const Content = object({
  mode: optional(string()),
  hideThumbnails: optional(string()),
  idPlaylist: optional(string()),
  setPlaylist: optional(string()),
  maxPlaylistVideos: optional(string()),
  showArrowsWithThumbnails: optional(string()),
  videos: optional(array(videosContent)),
  margin: optional(array(marginContent)),
  disclaimers: optional(array(disclaimersContent)),
});

export type FeatureAppContent = Infer<typeof Content>;

export function useFeatureAppContent(): FeatureAppContent {
  const { 'fa-content-service': contentService } = useFeatureServices();
  const content = contentService?.content;
  return is(content, Content) ? content : {};
}
